// extracted by mini-css-extract-plugin
module.exports = {"roundIcon":"fX","disabled":"fY"};